var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.36003 4.52637L1.5867 0.759699C1.52472 0.697213 1.45099 0.647617 1.36975 0.613771C1.28851 0.579926 1.20137 0.5625 1.11336 0.5625C1.02535 0.5625 0.938217 0.579926 0.856977 0.613771C0.775738 0.647617 0.702004 0.697213 0.640029 0.759699C0.515861 0.884607 0.446167 1.05357 0.446167 1.2297C0.446167 1.40582 0.515861 1.57479 0.640029 1.6997L3.94003 5.03303L0.640029 8.33303C0.515861 8.45794 0.446167 8.62691 0.446167 8.80303C0.446167 8.97916 0.515861 9.14812 0.640029 9.27303C0.701772 9.33602 0.775402 9.38614 0.856652 9.42047C0.937902 9.4548 1.02516 9.47266 1.11336 9.47303C1.20157 9.47266 1.28882 9.4548 1.37007 9.42047C1.45132 9.38614 1.52495 9.33602 1.5867 9.27303L5.36003 5.50637C5.4277 5.44394 5.4817 5.36817 5.51864 5.28384C5.55558 5.1995 5.57465 5.10843 5.57465 5.01637C5.57465 4.9243 5.55558 4.83323 5.51864 4.74889C5.4817 4.66456 5.4277 4.58879 5.36003 4.52637Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBtn);
export default __webpack_public_path__ + "static/media/arrow-right-btn.efe3b8123df835bd6a1beb8ea2a928f1.svg";
export { ForwardRef as ReactComponent };